
import InstructionChecklist from './InstructionChecklist'
import ChecklistCategory from './ChecklistCategory'
import AwardRankingCategory from './AwardRankingCategory'
import AwardRanking from './AwardRanking'
const routes = [
  {
    type: 'collapse',
    key: 'InstructionChecklist',
    route: '/',
    component: <AwardRankingCategory   />,
    
  },
  {
    type: 'collapse',
    key: 'home',
    route: '/:page_id',
    component: <AwardRanking   />,
  },

  
]

export default routes
